import { AudioManager } from "../../AudioManager";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Button";
import { BrandingLayer } from "./BrandingLayer";
import { CalendarLayer } from "./CalendarLayer";
import { CategoriesContainer } from "./categories/CategoriesContainer";
import { CategoryLayer } from "./categories/CategoryLayer";
import { FirstSessionLayer } from "./FirstSessionLayer";
import { SettingsLayer } from "./settings-layer/SettingsLayer";

export class SplashScene extends Phaser.Scene {

    public static currentInstance: SplashScene;
    public static instantiateBrandingLayer = true;
    public static firstSessionLayerSeen = false;

    public categoryLayer: CategoryLayer;
    public transitioning: boolean;
    public firstSessionLayer: FirstSessionLayer;
    public brandingLayer: BrandingLayer;
    public settingsLayer: SettingsLayer;
   
    private calendarLayer: CalendarLayer;
    private categoriesContainer: CategoriesContainer;
    private scrollingContainer: Phaser.GameObjects.Container;
    private settingsBtn: Button;
    private leftArrowButton: Button;
    private rightArrowButton: Button;
    private leftMask: Phaser.GameObjects.Image;
    private rightMask: Phaser.GameObjects.Image;
   
    constructor() {

        super("SplashScene");
    }

    public create(): void {

        SplashScene.currentInstance = this;
        
        GameManager.setCurrentScene(this);

        this.calendarLayer = null;
        this.transitioning = false;
        this.firstSessionLayer = null;
        this.brandingLayer = null;
        this.categoryLayer = null;
        this.settingsLayer = null;

        this.scrollingContainer = new Phaser.GameObjects.Container(this);
        this.add.existing(this.scrollingContainer);

        const background = new Phaser.GameObjects.Image(this, 0, 0, "background_level_selection_scene");
        background.setOrigin(0);
        background.scaleX = GameVars.scaleX;
        
        this.scrollingContainer.add(background);

        this.calendarLayer = new CalendarLayer(this);
        this.scrollingContainer.add(this.calendarLayer);

        this.categoriesContainer = new CategoriesContainer(this);
        this.scrollingContainer.add(this.categoriesContainer);
        
        this.settingsBtn = new Button(this, GameConstants.GAME_WIDTH - 50 * GameVars.scaleX, 50, "texture_atlas_1", "btn_settings_off", "btn_settings_off");
        this.settingsBtn.onDown(this.showSettingsLayer, this);
        this.settingsBtn.scaleX = GameVars.scaleX;
        this.settingsBtn.setInflationTween(1.1);
        this.add.existing(this.settingsBtn);

        const sc = <any> this;

        const swipeInput = sc.rexGestures.add.swipe(
            {
                enable: true,
                bounds: undefined,
                threshold: 10,
                velocityThreshold: 500,
                dir: "4dir",
            }
        );

        const self = this;

        const aspectRatio = window.innerWidth / window.innerHeight;

        const deltaX = Math.floor(450 * GameVars.scaleX);

        swipeInput.on("swipe", function (swipe: any): void {

            if (self.brandingLayer || self.firstSessionLayer || self.transitioning) {
                return;
            }

            if (this.categoryLayer) {

                if (swipe["up"]) {
                    self.categoryLayer.onWheel(null, null, null, -10);
                }
    
                if (swipe["down"]) {
                    self.categoryLayer.onWheel(null, null, null, 10);
                }

            } else {

                if ((aspectRatio < 1.65 || !GameVars.isMobile) && swipe["left"] && this.scrollingContainer.x === 0) {

                    self.scroll("left", self);
                }

                if ((aspectRatio < 1.65 || !GameVars.isMobile) && swipe["right"] && this.scrollingContainer.x === -deltaX ) {

                    self.scroll("right", self);
                }
            }

        }, this);

        // LAS FLECHAS PARA HACER SCROLL
        if (aspectRatio < 1.65 || !GameVars.isMobile) {

            this.leftMask = new Phaser.GameObjects.Image(this, 0, GameConstants.GAME_HEIGHT / 2, "texture_atlas_1", "fading_mask");
            this.leftMask.setOrigin(0, .5);
            this.leftMask.scaleX = -1;
            this.leftMask.x += this.leftMask.width;
            this.add.existing(this.leftMask);

            this.leftArrowButton = new Button(this, 25 * GameVars.scaleX, GameConstants.GAME_HEIGHT / 2, "texture_atlas_1", "arrow_scroll_menu_left", "arrow_scroll_menu_left");
            this.leftArrowButton.onDown(function(): void {
                this.scroll("right", this);
                AudioManager.playSound("btn_press");
            }, this);
            this.leftArrowButton.scaleX = GameVars.scaleX;
            this.add.existing(this.leftArrowButton);

            this.leftMask.visible = false;
            this.leftArrowButton.visible = false;

            this.rightMask = new Phaser.GameObjects.Image(this, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT / 2, "texture_atlas_1", "fading_mask");
            this.rightMask.setOrigin(1, .5);
            this.add.existing(this.rightMask);

            this.rightArrowButton = new Button(this, GameConstants.GAME_WIDTH - 25 * GameVars.scaleX, GameConstants.GAME_HEIGHT / 2, "texture_atlas_1", "arrow_scroll_menu_right", "arrow_scroll_menu_right");
            this.rightArrowButton.onDown(function(): void {
                this.scroll("left", this);
                AudioManager.playSound("btn_press");
            }, this);
            this.rightArrowButton.scaleX = GameVars.scaleX;
            this.add.existing(this.rightArrowButton);

            if (GameVars.gameData.firstSession) {
                this.tweens.add({
                    targets: this.rightArrowButton,
                    scaleX: 1.1 * GameVars.scaleX,
                    scaleY: 1.1,
                    duration: 500,
                    yoyo: true,
                    repeat: -1
                });
            }
        }

        // un texto de copyright
        const copyrightLabel = this.add.text(GameConstants.GAME_WIDTH - 10, GameConstants.GAME_HEIGHT - 10 * GameVars.scaleX, "a game made by RavalMatic", {fontFamily: "OpenSans-CondLight", fontSize: "32px", color: "#FFFFFF"});
        copyrightLabel.alpha = .6;
        copyrightLabel.setOrigin(1);
        copyrightLabel.setShadow(5, 5, "#000000", 6);
        copyrightLabel.scaleX = GameVars.scaleX;

        if (GameVars.gameData.firstSession && !SplashScene.firstSessionLayerSeen) {

            SplashScene.firstSessionLayerSeen = true;

            this.firstSessionLayer = new FirstSessionLayer(this);
            this.add.existing(this.firstSessionLayer);
        }

        if (SplashScene.instantiateBrandingLayer) {
            
            SplashScene.instantiateBrandingLayer = false;

            this.brandingLayer = new BrandingLayer(this);
            this.add.existing(this.brandingLayer);
        }

        this.input.keyboard.createCombo("IDDQD");

        this.input.keyboard.on("keycombomatch", function (event) {
            // Activar modo secreto aquí
            GameManager.activateSecretMode();
        });

        AudioManager.playSound("soundtrack_mahjong", true);
    }

    public showCategoryLayer(category: string): void {

        this.categoryLayer = new CategoryLayer(this, category);
        this.add.existing(this.categoryLayer);
    }

    public hideCategoryLayer(): void {

        this.categoryLayer.destroy();
        this.categoryLayer = null;
    }

    public removeBrandingLayer(): void {

        this.brandingLayer.destroy();
        this.brandingLayer = null;
    }

    public removeFirstSessionLayer(): void {
        
        this.firstSessionLayer.destroy();

        this.time.delayedCall(500, () => {
            this.firstSessionLayer = null;
        }, [], this);
    }

    public hideSettingsLayer(): void {

        if (this.settingsLayer) {
            this.settingsLayer.destroy();
        }
        this.settingsLayer = null;

        this.settingsBtn.visible = true;

        AudioManager.setLoopVolume(.3, 1);
    }

    private showSettingsLayer(): void {

        this.settingsLayer = new SettingsLayer(this);
        this.add.existing(this.settingsLayer);

        this.settingsBtn.visible = false;

        AudioManager.setLoopVolume(1, .3);

        AudioManager.playSound("btn_press");
    }

    private scroll(direction: string, self: SplashScene): void {

        self.transitioning = true;

        let x: number;

        if (direction === "left") {

            x = -Math.floor(450 * GameVars.scaleX);

            if (this.leftMask) {
                this.leftMask.visible = true;
                this.leftArrowButton.visible = true;
                this.rightMask.visible = false;
                this.rightArrowButton.visible = false;
            }

            this.tweens.killTweensOf(this.rightArrowButton);
            this.rightArrowButton.scaleX = GameVars.scaleX;
            this.rightArrowButton.scaleY = 1;

        } else {

            x = 0;

            if (this.leftMask) {
                this.leftMask.visible = false;
                this.leftArrowButton.visible = false;
                this.rightMask.visible = true;
                this.rightArrowButton.visible = true;
            }
        }

        this.tweens.add({
            targets: self.scrollingContainer,
            x: x,
            duration: 500,
            ease: Phaser.Math.Easing.Cubic.Out,
            onComplete: function(): void {
                self.transitioning = false;
            },
            onCompleteScope: self
        });
    }
}
